export const REQUEST_STATES = 'REQUEST_STATES'
export const RECEIVE_STATES = 'RECEIVE_STATES'
export const REQUEST_CITIES = 'REQUEST_CITIES'
export const RECEIVE_CITIES = 'RECEIVE_CITIES'
export const REQUEST_SAVE_ADDRESS = 'REQUEST_CREATE_ADDRESS'
export const RECEIVE_SAVE_ADDRESS = 'RECEIVE_CREATE_ADDRESS'
export const REQUEST_ADDRESS = 'REQUEST_ADDRESS'
export const RECEIVE_ADDRESS = 'RECEIVE_ADDRESS'
